/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeFeatureFlagCatalogDto,
  ApiEnvelopeFeatureFlagOperationResultDto,
  ApiEnvelopeFeatureFlagOverrideDto,
  ApiEnvelopeFeatureFlagOverrideListDto,
  FeatureFlagsAdminListOverridesParams,
  FeatureFlagsAdminRemoveOverrideParams,
  SetFeatureFlagOverrideRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type featureFlagsAdminGetCatalogResponse200 = {
  data: ApiEnvelopeFeatureFlagCatalogDto
  status: 200
}

export type featureFlagsAdminGetCatalogResponseSuccess = (featureFlagsAdminGetCatalogResponse200) & {
  headers: Headers;
};
;

export type featureFlagsAdminGetCatalogResponse = (featureFlagsAdminGetCatalogResponseSuccess)

export const getFeatureFlagsAdminGetCatalogUrl = () => {




  return `/api/admin/feature-flags/catalog`
}

export const useFeatureFlagsAdminGetCatalogHook = (): ( options?: RequestInit) => Promise<featureFlagsAdminGetCatalogResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getFeatureFlagsAdminGetCatalogUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type featureFlagsAdminListOverridesResponse200 = {
  data: ApiEnvelopeFeatureFlagOverrideListDto
  status: 200
}

export type featureFlagsAdminListOverridesResponse400 = {
  data: ApiEnvelopeFeatureFlagOverrideListDto
  status: 400
}

export type featureFlagsAdminListOverridesResponseSuccess = (featureFlagsAdminListOverridesResponse200) & {
  headers: Headers;
};
export type featureFlagsAdminListOverridesResponseError = (featureFlagsAdminListOverridesResponse400) & {
  headers: Headers;
};

export type featureFlagsAdminListOverridesResponse = (featureFlagsAdminListOverridesResponseSuccess | featureFlagsAdminListOverridesResponseError)

export const getFeatureFlagsAdminListOverridesUrl = (params?: FeatureFlagsAdminListOverridesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/feature-flags/overrides?${stringifiedParams}` : `/api/admin/feature-flags/overrides`
}

export const useFeatureFlagsAdminListOverridesHook = (): (params?: FeatureFlagsAdminListOverridesParams, options?: RequestInit) => Promise<featureFlagsAdminListOverridesResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: FeatureFlagsAdminListOverridesParams, options?: RequestInit) => {

        return customFetcher(getFeatureFlagsAdminListOverridesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type featureFlagsAdminSetOverrideResponse200 = {
  data: ApiEnvelopeFeatureFlagOverrideDto
  status: 200
}

export type featureFlagsAdminSetOverrideResponse400 = {
  data: ApiEnvelopeFeatureFlagOverrideDto
  status: 400
}

export type featureFlagsAdminSetOverrideResponseSuccess = (featureFlagsAdminSetOverrideResponse200) & {
  headers: Headers;
};
export type featureFlagsAdminSetOverrideResponseError = (featureFlagsAdminSetOverrideResponse400) & {
  headers: Headers;
};

export type featureFlagsAdminSetOverrideResponse = (featureFlagsAdminSetOverrideResponseSuccess | featureFlagsAdminSetOverrideResponseError)

export const getFeatureFlagsAdminSetOverrideUrl = () => {




  return `/api/admin/feature-flags/overrides`
}

export const useFeatureFlagsAdminSetOverrideHook = (): (setFeatureFlagOverrideRequest?: SetFeatureFlagOverrideRequest, options?: RequestInit) => Promise<featureFlagsAdminSetOverrideResponse> => {

      const customFetcher = useSfetchMutator();
      return (setFeatureFlagOverrideRequest?: SetFeatureFlagOverrideRequest, options?: RequestInit) => {

        return customFetcher(getFeatureFlagsAdminSetOverrideUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setFeatureFlagOverrideRequest)
  }
);
      }
  }


export type featureFlagsAdminRemoveOverrideResponse200 = {
  data: ApiEnvelopeFeatureFlagOperationResultDto
  status: 200
}

export type featureFlagsAdminRemoveOverrideResponse400 = {
  data: ApiEnvelopeFeatureFlagOperationResultDto
  status: 400
}

export type featureFlagsAdminRemoveOverrideResponseSuccess = (featureFlagsAdminRemoveOverrideResponse200) & {
  headers: Headers;
};
export type featureFlagsAdminRemoveOverrideResponseError = (featureFlagsAdminRemoveOverrideResponse400) & {
  headers: Headers;
};

export type featureFlagsAdminRemoveOverrideResponse = (featureFlagsAdminRemoveOverrideResponseSuccess | featureFlagsAdminRemoveOverrideResponseError)

export const getFeatureFlagsAdminRemoveOverrideUrl = (params?: FeatureFlagsAdminRemoveOverrideParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/feature-flags/overrides?${stringifiedParams}` : `/api/admin/feature-flags/overrides`
}

export const useFeatureFlagsAdminRemoveOverrideHook = (): (params?: FeatureFlagsAdminRemoveOverrideParams, options?: RequestInit) => Promise<featureFlagsAdminRemoveOverrideResponse> => {

      const customFetcher = useSfetchMutator();
      return (params?: FeatureFlagsAdminRemoveOverrideParams, options?: RequestInit) => {

        return customFetcher(getFeatureFlagsAdminRemoveOverrideUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


